/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".vehicle-select[_ngcontent-%COMP%] {\n  opacity: 0.9;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.5);\n  background-color: white; }"];
export { styles as styles };
